// extracted by mini-css-extract-plugin
export default {"logo":"fE5vL_fE5vL","motto":"sY3Ea_sY3Ea","underline":"HoaoW_HoaoW"};